<template>
  <div id="map" :style="vstyle" v-loading="loading" class="project_map"></div>
</template>
<script>
import MindElixir from '@/components/minder/MindElixir'
export default {
  props: {
    vstyle: {
      type: String,
      default: 'position: absolute;width: 100%;top: 0px;left: 0;bottom: 0;',
    },
    prjCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      data: {},
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ME() {
      return new MindElixir({
        el: '#map',
        direction: MindElixir.RIGHT,
        data: {
          nodeData: this.data,
        },
        editable: false,
        draggable: false, // default true
        contextMenu: false, // default true
        toolBar: {
          lt: false,
        }, // default true
        nodeMenu: false, // default true
        keypress: false, // default true
        merouter: (path) => {
          this.$router.push(path)
        },
      })
    },
  },
  methods: {
    init() {
      this.loading = true
      this.$api.projectMapLoadData({ prjCode: this.prjCode }).then((res) => {
        this.data = res.body
        this.ME.init()
        this.loading = false
      })
    },
  },
}
</script>
<style lang="scss">
.map-container {
  ng tpc {
    text:nth-child(2) {
      font-size: 12px;
      color: #737373;
    }
  }
}
</style>
